import { useContext } from "react";

import {
  EnterpriseContext,
  EnterpriseContextType,
} from "@/context/EnterpriseContext";

/**
 * Hook to access enterprise data from EnterpriseContext
 *
 * @returns Enterprise context with full enterprise object and helper functions
 * @throws Error if used outside of EnterpriseProvider
 *
 * @example
 * ```typescript
 * const { enterprise, isDemo, isPro, hasAddon } = useEnterprise();
 *
 * // Access full enterprise object
 * console.log(enterprise?.name);
 *
 * // Use computed values
 * if (isDemo) { ... }
 *
 * // Use helper functions
 * if (hasAddon("NATURAL_CAPITAL")) { ... }
 * ```
 */
export const useEnterprise = (): EnterpriseContextType => {
  const context = useContext(EnterpriseContext);

  if (context === undefined) {
    throw new Error(
      "useEnterprise must be used within an EnterpriseProvider. " +
        "Ensure your component is wrapped in the provider at _app.tsx level."
    );
  }

  return context;
};
